// Копия витрины: site/src/shared/components/blocks/CoverBlock/getCoverOverlay.ts.
import { alpha } from "@mui/material/styles";

export type CoverAlign = "left" | "center" | "right";

/** Затемнение обложки со стороны текста (макет 1a): текст слева, градиент слева. */
export function getCoverOverlay(align: CoverAlign, bg: string): string {
  if (align === "center") {
    const veil = alpha(bg, 0.55);
    return `linear-gradient(${veil}, ${veil})`;
  }
  const angle = align === "left" ? 90 : 270;
  return `linear-gradient(${angle}deg, ${alpha(bg, 0.92)} 0%, ${alpha(bg, 0.55)} 45%, ${alpha(bg, 0.1)} 75%)`;
}
